import AssetList from '@/ui/components/asset-list';
import Page from '@/ui/components/page';
import exodus from '@/ui/exodus';
import useEnrichedCombinedAssets from '@/ui/hooks/use-enriched-combined-assets';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import { cn } from '@/ui/utils/classnames';
import Actions from './components/actions.js';
import Callouts from './components/callouts.js';
import Hero from './components/hero.js';

function TokensPage() {
  const assets = useEnrichedCombinedAssets();

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'WalletView',
    });
  }, []);

  // ATTENTION: Keep layout consistent with loading state in `index.html`.
  return (
    <Page
      className="flex h-full flex-col items-center"
      scrollContainerClassName="overflow-visible"
    >
      <Hero />
      <Actions />
      <Callouts />
      <AssetList
        assets={assets}
        className={cn(
          'mt-4',
          'pb-[104px]', // 104px padding to accommodate for the floating navbar.
          __STANDALONE_MODE__ && 'sm:pb-8', // The floating navbar is outside the page layout in standalone mode.
        )}
      />
    </Page>
  );
}

export default TokensPage;
